import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'types/index';

import { initialState } from './slice';

const selectDomain = (state: RootState) => state.allowList || initialState;

export const selectAllowList = createSelector(
  [selectDomain],
  allowListState => allowListState,
);
